<template>
  <div class="main-content">
    <div v-if="!btnInfo.id" class="empty color-Gray_9e">选择一个按钮后开始编辑</div>
    <template v-else>
      <div class="title">
        正在编辑按钮
        <span style="margin-left: 20px">
          <el-button type="primary" size="small" @click="$emit('save')">保存</el-button>
        </span>
      </div>
      <div class="content-box">
        <div class="left-box no-bar">
          <div class="content-item">
            <div class="item-title">按钮名称</div>
            <el-input
              v-model="btnInfo.name"
              placeholder="请填写按钮名称，不超过30个字符"
              :maxlength="30"
              size="small"
              class="mTop16"
            ></el-input>
          </div>
          <div class="content-item">
            <div class="item-title">APP端显示图标</div>
            <div class="mTop16" style="display: flex; flex-wrap: wrap; align-items: center">
              <span
                class="icon-info"
                :style="
                  btnInfo.color ? 'background:' + btnInfo.color : 'background:' + btnColors[0]
                "
              >
                <svg-icon
                  :style="
                    !btnInfo.color || btnInfo.color === '#f5f7fa' ? 'color:#313132' : 'color:#fff'
                  "
                  :icon-class="btnInfo.icon ? 'button_' + btnInfo.icon : 'button_' + btnIcons[0]"
                ></svg-icon>
              </span>
              <design-icon-popper
                style="margin: 14px 8px;"
                :colors="btnColors"
                :icons="btnIcons"
                :cur-data="btnInfo"
                from="button"
                @changeData="changeBtnInfo"
              ></design-icon-popper>
            </div>
          </div>
          <div class="content-item">
            <div class="item-title">按钮描述</div>
            <el-input
              v-model="btnInfo.desc"
              placeholder="请添加描述"
              size="small"
              class="mTop16"
            ></el-input>
          </div>
          <div class="content-item">
            <div class="item-title">触发数据</div>
            <normal-select
              class="mTop16"
              :select-list="triggerTypeList"
              :selected-item.sync="btnInfo.triggerType"
              @handle-select="setData"
            ></normal-select>
          </div>
          <div class="content-item" v-if="['SINGLE', 'LIST'].includes(btnInfo.triggerType)">
            <div class="item-title">按钮启用条件</div>
            <el-radio-group v-model="enableCondition">
              <el-radio label="all" class="mTop16">一直</el-radio>
              <el-radio label="filters" class="mTop16">满足筛选条件</el-radio>
            </el-radio-group>
            <condition-list
              v-show="enableCondition == 'filters'"
              class="condition-list"
              :conditions="btnInfo.filters"
              :search-sheet="sheet"
              :rely-sheet="sheet"
            ></condition-list>
          </div>
          <div class="content-item">
            <div class="item-title">点击后</div>
            <el-radio-group v-model="btnInfo.actionType" @change="actionTypeChange">
              <el-radio label="DIRECT" class="mTop16">立即执行</el-radio>
              <el-radio label="CONFIRM" class="mTop16">需要二次确认</el-radio>
              <el-radio
                label="FILL"
                v-if="!['LIST', 'NONE'].includes(btnInfo.triggerType)"
                class="mTop16"
              >
                填写指定内容
              </el-radio>
            </el-radio-group>
            <div v-if="btnInfo.actionType == 'CONFIRM'" class="setting-content">
              <div class="main">
                <p>
                  <span class="label">提示文字</span>
                  <span v-if="!editcConfirmMsg" class="value">
                    {{ btnInfo.confirmMsg }}
                  </span>
                  <el-input
                    v-else
                    ref="editcConfirmMsg"
                    v-model="btnInfo.confirmMsg"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    autofocus
                    resize="none"
                    size="small"
                    @blur="editcConfirmMsg = false"
                  ></el-input>
                </p>
              </div>
              <span><i class="el-icon-edit" @click="showInput"></i></span>
            </div>
            <div v-else-if="btnInfo.actionType == 'FILL'" class="setting-content">
              <div class="main">
                <span class="mRight10">在</span>
                <b class="mRight10">{{ fillObjStr }}</b>
                <span>中</span>
                <div style="margin-top: 6px">
                  <span class="mRight10">{{ fillContent }}</span>
                  <b v-if="fillContent == '填写'">
                    {{ getFieldsText(btnInfo.fillCids) }}
                  </b>
                  <b v-else>{{ fillContentStr }}</b>
                </div>
              </div>
              <span>
                <i class="el-icon-edit" @click="$refs.fieldSettingDialog.open(btnInfo)"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="rigth-box no-bar">
          <other-setting :btn-info="btnInfo" :app-id="appId"></other-setting>
        </div>
      </div>
      <field-setting-dialog
        ref="fieldSettingDialog"
        :sheet-def="sheet"
        :fields-info-map="fieldsInfoMap"
        :available-sheets="availableSheets"
        @submit="Object.assign(btnInfo, $event)"
      ></field-setting-dialog>
    </template>
  </div>
</template>

<script>
import OtherSetting from "./other-setting"
import DesignIconPopper from "@/components/BaseComponents/DesignIconPopper"
import { btnIcons, btnColors, triggerTypeList } from "./static"
import { getWorkflow } from "@/api/workflow/workflow"
import FieldSettingDialog from "@/views/Backend/AdminEdit/Sheet/CustomButton/FieldSettingDialog"
import ConditionList from "@/components/UIComponents/ConditionList/ConditionList"
import { getAllDefaultControls } from "@/api/sheet/sheet"
import NormalSelect from "@/components/UIComponents/NormalSelect"

export default {
  name: "main-content",
  components: {
    NormalSelect,
    ConditionList,
    FieldSettingDialog,
    OtherSetting,
    DesignIconPopper
  },
  props: {
    btnInfo: Object,
    sheet: Object,
    availableSheets: Array
  },
  data() {
    return {
      btnIcons,
      btnColors,
      triggerTypeList,
      name: "按钮",
      desc: "按钮描述",
      actionType: "DIRECT", // ["DIRECT", "CONFIRM", "FILL"]
      confirmMsg: "你确认对记录执行此操作吗？",
      editcConfirmMsg: false, // 显示编辑确认信息的文本框
      enableCondition: "all", // ["all", "filters"]
      controlTypeMap: {}
    }
  },
  watch: {
    "btnInfo.flowId": {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.btnInfo.filters = this.btnInfo.filters || []
            this.enableCondition = this.btnInfo.filters.length != 0 ? "filters" : "all"
          })
          getWorkflow(newVal).then(rsp => {
            this.$set(this.btnInfo, "flowName", rsp.name)
            this.$set(this.btnInfo, "flowEnable", rsp.enable)
          })
        } else {
          this.$set(this.btnInfo, "flowName", null)
        }
      },
      immediate: true
    }
  },
  computed: {
    appId() {
      return this.sheet.appId
    },
    fieldsInfoMap() {
      return this.availableSheets
        .flatMap(app => app.sheets)
        .flatMap(sheet => sheet.controls)
        .reduce(
          (acc, cur) =>
            Object.assign(acc, { [cur._cid]: `[${this.controlTypeMap[cur._type]}] ${cur.name}` }),
          {}
        )
    },
    fillObjStr() {
      if (!this.btnInfo.refCid) return "当前记录"
      let control = (this.sheet?.controls || []).find(
        control => control._cid === this.btnInfo.refCid
      )
      if (!control) return "【字段已删除】"
      return `[关联表] ${control.name}`
    },
    fillContent() {
      if (this.btnInfo.fillType && this.btnInfo.fillType == "CREATE_REF") return "新建并关联"
      else return "填写"
    },
    fillContentStr() {
      let cid = this.btnInfo.fillCids[0]?.cid
      if (!cid) return ""
      return this.fieldsInfoMap[cid]
    }
  },
  created() {
    getAllDefaultControls().then(
      controls =>
        (this.controlTypeMap = controls.reduce(
          (acc, cur) => Object.assign(acc, { [cur._type]: cur.name }),
          {}
        ))
    )
  },
  methods: {
    // 选中填写指定内容时，若fillCids不存在则初始化
    actionTypeChange(actionType) {
      if (actionType == "FILL" && !this.btnInfo.fillCids) this.btnInfo.fillCids = []
    },
    // 显示确认信息填写框
    showInput() {
      this.editcConfirmMsg = true
      this.$nextTick(() => {
        this.$refs.editcConfirmMsg.focus()
      })
    },
    changeBtnInfo(key, val) {
      this.$set(this.btnInfo, key, val)
    },
    // 获取填写字段的展示文字
    getFieldsText(fillCids) {
      if (this._.isEmpty(fillCids) || this._.isEmpty(this.fieldsInfoMap)) return ""
      return fillCids.map(i => this.fieldsInfoMap[i.cid]).join("、")
    },
    setData(item) {
      this.btnInfo.filters = []
      this.btnInfo.batchEnable = ["LIST", "NONE"].includes(item.value)
      if (["LIST", "NONE"].includes(item.value)) {
        this.btnInfo.actionType = "DIRECT"
        this.btnInfo.fillCids = []
        this.btnInfo.validateFlowId = ""
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding-bottom: 30px;
    height: 100%;
    font-size: 14px;
  }
  .title {
    height: 50px;
    line-height: 50px;
    padding: 0 24px;
    font-size: 17px;
    box-sizing: border-box;
    border-bottom: 1px solid #ddd;
  }
  .content-box {
    display: flex;
    .left-box,
    .rigth-box {
      width: 50%;
      box-sizing: border-box;
      border-right: 1px solid #eee;
      height: calc(100vh - 55px - 50px);
      padding: 14px 24px;
      font-size: 14px;
      overflow-y: scroll;
    }
    .rigth-box {
      border: none;
    }
    ::v-deep .content-item {
      &:not(:first-child) {
        margin-top: 28px;
      }
      .item-title {
        font-weight: bold;
      }
      .setting-content {
        display: flex;
        margin-top: 10px;
        width: 100%;
        background: #f5f5f5;
        border: 1px solid #ddd;
        border-radius: 3px;
        padding: 8px 16px 10px;
        box-sizing: border-box;
        color: #333;
        .main {
          flex: 1 1;
          p {
            display: flex;
            line-height: 22px;
            padding: 0;
            margin: 0;
            .label {
              width: 100px;
            }
            .value {
              flex: 1 1;
              font-weight: bold;
            }
          }
        }
        .el-icon-edit {
          padding: 3px;
          cursor: pointer;
          &:hover {
            color: #2196f3;
          }
        }
      }
    }
    .icon-info {
      display: flex;
      background: #f5f7fa;
      justify-content: center;
      align-items: center;
      width: 38px;
      height: 38px;
      font-size: 20px;
      border-radius: 6px;
    }
  }
}
</style>
